import { useQuery } from '@tanstack/react-query'
import { lcCoachingApi } from '@/api/lcCoaching'
import { coachingKeys } from '@/hooks/coaching/useCoachingToday'

/**
 * 레슨 가이드(교과정보/생각열기/핵심체크 5점) 조회 (Phase 6a, §5-12/§5-13/§5-신규).
 * 포커스 레슨(lessonId) 기준. lessonId 가 없으면(레슨 없음) 비활성 — 패널이 안내를 표시한다.
 */
export function useCoachingGuide(
  learnerId: number,
  lessonId: number | null,
  learningAttemptId: number | null = null,
  enabled = true,
) {
  return useQuery({
    queryKey: coachingKeys.guide(learnerId, lessonId ?? 0, learningAttemptId),
    queryFn: () => lcCoachingApi.getGuide(learnerId, lessonId as number, learningAttemptId),
    enabled: enabled && learnerId > 0 && lessonId != null,
  })
}
